var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 760,
    viewBox: "0 0 720 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 760,
    fill: "#1A1425"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_189_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -720,
    y: 135,
    width: 1440,
    height: 625,
    fill: "url(#paint0_linear_189_215)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_189_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -720,
    y: 135,
    width: 1440,
    height: 625,
    fill: "url(#paint1_linear_189_215)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_189_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 62,
    transform: "matrix(1 0 0 -1 -720 708)",
    fill: "url(#paint2_linear_189_215)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_189_215",
    x: -870,
    y: -15,
    width: 1740,
    height: 925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_189_215"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_189_215",
    x: -870,
    y: -15,
    width: 1740,
    height: 925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_189_215"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_189_215",
    x: -920,
    y: 446,
    width: 1840,
    height: 462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_189_215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_215",
    x1: 113,
    y1: 448,
    x2: 403,
    y2: 1033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_189_215",
    x1: 113,
    y1: 448,
    x2: 161,
    y2: 747.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4F96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_189_215",
    x1: 1440,
    y1: 31,
    x2: 0,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB5097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367217,
    stopColor: "#CF489E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9E55C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 760,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/loginBackground.b6415ed4fc3234d925003825445973ab.svg";
export { ForwardRef as ReactComponent };